const supply_chain_healthcare_positions = ['Manufacturer', 'Distributor', 'Healthcare Organization', 'Provider', "N/A"]

const supply_chain_financial_positions = ['Asset Originator', 'Investment Bank', 'Financial Intermediary', 'End Client', "N/A"]

const supply_chain_technology_positions = ['Component Manufacturer', 'System Integrator', 'Distributor', 'End User', "N/A"]

const supply_chain_consumer_discretionary_positions = ['Raw Material Supplier', 'Manufacturer', 'Wholesaler', 'Retailer', "N/A"]

const supply_chain_consumer_staples_positions = ['Raw Material Producer', 'Processor', 'Distributor', 'Retailer', "N/A"]

const supply_chain_industrials_positions = ['Raw Material Supplier', 'Component Manufacturer', 'Equipment Manufacturer', 'Industrial Distributor', "N/A"]

const supply_chain_energy_positions = ['Exploration & Production', 'Processor/Refiner', 'Distributor', 'Utility/Retailer', "N/A"]

const supply_chain_materials_positions = ['Raw Material Extractor', 'Primary Processor', 'Secondary Processor', 'Distributor', "N/A"]

const supply_chain_utilities_positions = ['Resource Generator', 'Transmission Provider', 'Distribution Operator', 'Retail Provider', "N/A"]

const supply_chain_real_estate_positions = ['Developer', 'Property Manager', 'Broker/Agent', 'Service Provider', "N/A"]

const supply_chain_communication_services_positions =  ['Infrastructure Provider', 'Network Operator', 'Service Provider', 'Content Creator', "N/A"]

const supply_chain_government_positions =  ['Policy Maker', 'Administrator', 'Service Provider', 'Public Agency', "N/A"]


export const supplyChainPositionDef = {
    "Healthcare": supply_chain_healthcare_positions,
    "Financials": supply_chain_financial_positions,
    "Technology": supply_chain_technology_positions,
    "Consumer Discretionary": supply_chain_consumer_discretionary_positions,
    "Consumer Staples": supply_chain_consumer_staples_positions,
    "Industrials": supply_chain_industrials_positions,
    "Energy": supply_chain_energy_positions,
    "Materials": supply_chain_materials_positions,
    "Utilities": supply_chain_utilities_positions,
    "Real Estate": supply_chain_real_estate_positions,
    "Communication Services": supply_chain_communication_services_positions,
    "Government/Public Sector": supply_chain_government_positions
}